import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Loading from "../../../components/customHelpers/Loading";

import { TableBody, TableRow, TableCell } from "@material-ui/core";

import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";

import { MdOutlineDelete } from "react-icons/md";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { useLocation } from "react-router-dom";
import { TextField } from "@mui/material";
const headCells = [
  { id: "productName", label: "Product" },
  { id: "discount", label: "Discount" },
  { id: "store", label: "Store" },
  { id: "sku", label: "Sku" },
  { id: "price", label: "Price" },
  { id: "quantity", label: "Quantity" },
  { id: "totalprice", label: "TotalPrice" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const OrderTable = ({
  productLists,

  setData,
  paid,
  setPaid,
  setProducts,
  products,
  tempProducts,
}) => {
  const { NotifyMessage, notify, setNotify } = Notify();
  const [orders, setOrders] = useState([]);
  const [quantityError, setQuantityError] = useState({});

  useEffect(() => {
    setOrders(productLists);
  }, [productLists]);

  const [Id, setId] = useState();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const onDelete = (item, quantity) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    removeOrderItem(item, quantity);
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(orders, headCells, filterFn);

  const removeOrderItem = (item, quantity) => {
    setOrders((prevOrders) => {
      return prevOrders.filter(
        (order) =>
          !(
            order.product === item.product &&
            Number(order.price.trim()) === Number(item.price.trim()) &&
            Number(order.discount) === Number(item.discount)
          )
      );
    });

    setData((prevOrders) => {
      return prevOrders.filter(
        (order) =>
          !(
            order.product === item.product &&
            Number(order.price.trim()) === Number(item.price.trim()) &&
            Number(order.discount) === Number(item.discount)
          )
      );
    });
    setPaid(paid - calculateTotalPrice());
    const updatedProducts = products.map((product) =>
      product.id === item.product
        ? { ...product, quantity: product.quantity + quantity }
        : product
    );
    setProducts(updatedProducts);
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    if (orders.length > 0) {
      orders.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2); // Return the total price rounded to 2 decimal places
    }
  };
  const handleQuantityChange = (productId, newQuantity) => {
    const existingProduct = tempProducts?.find((item) => item.id === productId);

    if (existingProduct && newQuantity > existingProduct.quantity) {
      setQuantityError((prevErrors) => ({
        ...prevErrors,
        [productId]: `Quantity exceeds available stock! (${existingProduct.quantity} available)`,
      }));
    } else {
      setQuantityError((prevErrors) => ({
        ...prevErrors,
        [productId]: "", // Clear the error for this product
      }));

      setOrders((prevOrders) => {
        const updatedOrders = prevOrders.map((order) => {
          if (order.product === productId) {
            return {
              ...order,
              quantity: newQuantity,
              totalPrice: newQuantity * order.price,
            };
          }
          return order;
        });

        // Update only if there's a change
        if (JSON.stringify(updatedOrders) !== JSON.stringify(prevOrders)) {
          setData(updatedOrders);
        }
        return updatedOrders;
      });
    }
  };

  // Input Field

  return (
    <div className="card">
      <Grid container>
        <Grid item xs={12} className="card__body">
          {loading ? (
            <Loading />
          ) : (
            <>
              {" "}
              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().length > 0
                    ? recordsAfterPagingAndSorting().map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.productName}</TableCell>
                          <TableCell>{item.discount}</TableCell>
                          <TableCell>{item.store}</TableCell>
                          <TableCell>{item.sku}</TableCell>
                          <TableCell>{item.price}</TableCell>
                          <TableCell>{item.quantity}</TableCell>
                          <TableCell>{item.totalPrice}</TableCell>
                          <TableCell>
                            <Controls.ActionButton
                              color="secondary"
                              title="Delete"
                              onClick={() => {
                                setConfirmDialog({
                                  isOpen: true,
                                  title: "Are you sure to remove this Order?",
                                  subTitle: "You can't undo this operation",
                                  onConfirm: () => {
                                    onDelete(item, item.quantity);
                                  },
                                });
                              }}
                            >
                              <MdOutlineDelete fontSize="medium" />
                            </Controls.ActionButton>
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </>
          )}
        </Grid>
      </Grid>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default OrderTable;
